import React, { useEffect, useRef, useState } from "react";
import "./Roadmap.css";
import {
  FaFileSignature,
  FaShoppingCart,
  FaTools,
  FaCogs,
  FaRocket,
  FaSyncAlt,
} from "react-icons/fa";

const phases = [
  {
    week: "WEEK 1",
    title: "Agreement",
    icon: <FaFileSignature />,
    points: ["MOU Signing", "PO Receipt", "75% Advance Paid", "Kickoff in 3 Days"],
  },
  {
    week: "WEEK 1–2",
    title: "Procurement",
    icon: <FaShoppingCart />,
    points: ["Source Components", "Assembly & QC", "Kit Config", "Logistics"],
  },
  {
    week: "WEEK 2–3",
    title: "Lab Setup",
    icon: <FaTools />,
    points: ["Furniture", "Networking", "Branding", "Safety"],
  },
  {
    week: "WEEK 3–4",
    title: "Commissioning",
    icon: <FaCogs />,
    points: ["Install", "Config", "Engineer", "Testing"],
  },
  {
    week: "WEEK 4",
    title: "Launch",
    icon: <FaRocket />,
    points: ["Event", "Batch Start", "Payment", "Handover"],
  },
  {
    week: "MONTH 2+",
    title: "Operations",
    icon: <FaSyncAlt />,
    points: ["Training", "Experts", "Projects", "Review"],
  },
];

export default function Roadmap() {
  const [visible, setVisible] = useState([]);
  const [startAnim, setStartAnim] = useState(false);
  const sectionRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStartAnim(true);

          phases.forEach((_, i) => {
            setTimeout(() => {
              setVisible((prev) => [...prev, i]);
            }, i * 800); // stagger
          });
        }
      },
      { threshold: 0.3 }
    );

    observer.observe(sectionRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <div className="roadmap-section" ref={sectionRef}>

      <div className="roadmap-header">
        <span className="dot" />
        <h4>IMPLEMENTATION ROADMAP</h4>
        <div className="badge">6 Phases · 30 Days</div>
      </div>

      <h2 className="roadmap-title">
        30-Day Setup → Ongoing Operations
      </h2>

      {/* CURVED LINE */}
      <div className="roadmap-line">
        <svg viewBox="0 0 1000 80">

          <path
            d="M0,50 C150,10 300,80 500,40 C700,0 850,70 1000,30"
            className="roadmap-path"
          />

          <path
            d="M0,50 C150,10 300,80 500,40 C700,0 850,70 1000,30"
            className={`roadmap-progress-path ${startAnim ? "animate-line" : ""}`}
          />

        </svg>
      </div>

      <div className="roadmap-grid">
        {phases.map((phase, i) => (
          <div key={i} className={`phase ${visible.includes(i) ? "show" : ""}`}>

            <div className="circle">
              {phase.icon}
            </div>

            <span className="week">{phase.week}</span>
            <h3>{phase.title}</h3>

            <div className="phase-card">
              {phase.points.map((p, idx) => (
                <p key={idx}>✔ {p}</p>
              ))}
            </div>

          </div>
        ))}
      </div>

    </div>
  );
}